package com.exura.features.firebase.domain.model

import dev.gitlive.firebase.firestore.CollectionReference
import dev.gitlive.firebase.firestore.DocumentReference

interface SerializableDomainModel {
    val firebaseDocId: String?

    /**
     * Optional prefix for the document ID to provide context or categorization
     */
    val firebaseDocPrefix: CollectionReference?

    fun getFirebaseDocRef(prefix: CollectionReference? = null, id: String? = null): DocumentReference {
        val finalPrefix = prefix ?: firebaseDocPrefix
            ?: throw IllegalArgumentException("Need to provide at least one path to get document reference")
        val finalId = id ?: firebaseDocId
            ?: throw IllegalArgumentException("Need to provide at least one id to get document reference")
        return finalPrefix.document(finalId)
    }

}
